import moment from 'moment';
import {
    CHANGE_SLIDE_ITEM,
    RESET_BANNER,
    VALIDATE_BANNER,
} from '../actions/bannerActionTypes';
import { validateUrl } from '../../../../shared/utils/strings';
import { CHANGE_CAMPAIGN_FIELD } from '../actions/actionTypes';

const CAMPAIGN_FIELDS = {
    END_CAMPAIGN: 'endCampaign',
    PAGE: 'page',
    START_CAMPAIGN: 'startCampaign',
};

const initialState = {
    banner: {
        0: {
            description: '',
            fake_image: '',
            image: '',
            position: 0,
            url_destination: '',
        },
    },
    callToAction: 'book_now',
    slideWithError: {
        image: false,
        url_destination: false,
    },
};

const validateDate = ({ rule, endDate, startDate }) => {
    if (moment(startDate).isSame(endDate)) return true;
    if (rule === 'isBefore') return endDate ? moment(startDate).isBefore(endDate) : true;
    return startDate ? moment(endDate).isAfter(startDate) : true;
};

const checkCampaign = (state, action = {}) => {
    const { fieldName } = action;

    const {
        endCampaign,
        fieldsWithError: fieldsWithErrorState,
        page,
        startCampaign,
    } = state;

    let fieldsWithError = {};

    const isStartCampaignValid = fieldName === CAMPAIGN_FIELDS.START_CAMPAIGN ? validateDate({
        endDate: endCampaign,
        startDate: startCampaign,
        rule: 'isBefore',
    }) : true;

    const isEndCampaignValid = fieldName === CAMPAIGN_FIELDS.END_CAMPAIGN ? validateDate({
        endDate: endCampaign,
        startDate: startCampaign,
        rule: 'isAfter',
    }) : true;

    const isPageValid = fieldName === CAMPAIGN_FIELDS.PAGE ? page : true;

    const isActionEmpty = !Object.keys(action).length;

    if (isActionEmpty) {
        fieldsWithError = Object.assign({}, fieldsWithError, {
            [CAMPAIGN_FIELDS.PAGE]: !state.page,
            [CAMPAIGN_FIELDS.START_CAMPAIGN]: !state.startCampaign,
        });
        return { ...state, fieldsWithError };
    }

    if (!isStartCampaignValid || !isEndCampaignValid || !isPageValid) {
        fieldsWithError = Object.assign({}, fieldsWithError, { [fieldName]: true });
        return { ...state, fieldsWithError, [fieldName]: null };
    }

    return {
        ...state,
        fieldsWithError: {
            ...fieldsWithErrorState,
            [fieldName]: false,
        },
    };
};

const changeCampaignField = (state, action) => {
    const { field, value } = action;

    const newState = {
        ...state,
        [field]: value,
    };

    const { fieldsWithError, ...rest } = checkCampaign(newState, action);
    const hasFieldWithError = Object.values(fieldsWithError).length > 0;

    if (hasFieldWithError) return { fieldsWithError, ...rest };
    return newState;
};

const resetBanner = () => ({
    ...initialState,
});

const validateBanner = (state) => {
    const { banner } = state;
    const { image, url_destination: url } = banner[0];

    let isSlideWithError = Object.create(state.slideWithError);
    if (!image) {
        isSlideWithError = {
            ...isSlideWithError,
            image: true,
        };
    }
    const isUrlValid = validateUrl(url);
    if (!url || !isUrlValid) {
        isSlideWithError = {
            ...isSlideWithError,
            url_destination: true,
        };
    }

    return {
        ...state,
        slideWithError: isSlideWithError,
    };
};

const changeSlideItem = (state, action) => {
    const { banner, slideWithError } = state;

    const updatedBanner = {
        ...banner[0],
        [action.field]: action.value,
    };

    const newState = {
        ...state,
        banner: {
            0: updatedBanner,
        },
        slideWithError: {
            ...slideWithError,
            [action.field]: false,
        },
    };

    return newState;
};

const bannerReducer = (state = initialState, action) => {
    let newState = {};
    switch (action.type) {
    case RESET_BANNER: newState = resetBanner(state); break;
    case CHANGE_SLIDE_ITEM: newState = changeSlideItem(state, action); break;
    case CHANGE_CAMPAIGN_FIELD: newState = changeCampaignField(state, action); break;
    case VALIDATE_BANNER: newState = validateBanner(state); break;
    default:
        newState = state;
    }

    return newState;
};

export default bannerReducer;
